import { render, staticRenderFns } from "./user-header.vue?vue&type=template&id=cdcee49c&scoped=true&"
import script from "./user-header.vue?vue&type=script&lang=js&"
export * from "./user-header.vue?vue&type=script&lang=js&"
import style0 from "./user-header.vue?vue&type=style&index=0&id=cdcee49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcee49c",
  null
  
)

export default component.exports